<template>
  <CModal :is-open="isOpen" is-centered :closeOnOverlayClick="true" :on-close="close">
    <CModalContent maxW="350px" mx="16px" borderRadius="16px" p="24px"
boxShadow="lg">
      <CModalBody p="0">
        <OmtTypography
          as="h2-bold"
          mb="16px"
          textAlign="left"
          fontSize="16px"
          fontWeight="700"
          fontStyle="normal"
          lineHeight="18px"
          letterSpacing="0"
          color="#4E4E4E"
        >
          Você será direcionado para uma página externa.
        </OmtTypography>
        <OmtTypography
          as="p1"
          mb="16px"
          textAlign="left"
          fontSize="14px"
          fontWeight="400"
          fontStyle="normal"
          lineHeight="22px"
          letterSpacing="0"
          color="#4E4E4E"
        >
          A cotação do Seguro Viagem será realizada no site da Omint, em um ambiente seguro.
        </OmtTypography>
        <OmtButton w="100%" mb="16px"
@click="confirmRedirect">
          <OmtTypography as="button-medium" color="white"> Continuar </OmtTypography>
        </OmtButton>
        <OmtButton w="100%" variant="ghost" color="var(--colors-light-primary-navy-blue)" @click="close">
          <OmtTypography as="button-medium" color="var(--colors-light-primary-navy-blue)"> Cancelar </OmtTypography>
        </OmtButton>
      </CModalBody>
    </CModalContent>
    <CModalOverlay />
  </CModal>
</template>

<script>
import { CModal, CModalBody, CModalContent, CModalOverlay } from "@chakra-ui/vue";

export default {
  components: { CModal, CModalOverlay, CModalContent, CModalBody },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit("update:isOpen", false);
    },
    confirmRedirect() {
      this.$emit("confirm");
      this.close();
    }
  }
};
</script>
